import React, { useState } from 'react';

const CompanyTile = ({ id, name, image, onClick, description }) => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const [imageError, setImageError] = useState(false);

  return (
    <div
      key={id}
      className="relative bg-white p-3 animate-fade-in
                 flex items-center
                 active:bg-gray-50
                 transition-all duration-150 ease-out
                w-full cursor-pointer
                 mb-3
                 border border-gray-400 !rounded-2xl
                 "
      onClick={onClick}
      aria-label={`Sélectionner ${name}`}
      title={name}
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick();
        }
      }}
    >
      <div className="flex items-center w-full">
        {imageError && (
          <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-gray-100">
            <span className="text-gray-500 font-medium text-lg">{name[0]}</span>
          </div>
        )}

        {!imageError && (
          <div className="w-20 h-20 p-2 rounded-xl bg-zinc-100 flex items-center justify-center">
            <img
              className={`w-full h-full object-contain transition-opacity duration-300 ${
                imageLoaded ? 'opacity-100' : 'opacity-0'
              }`}
              src={image}
              alt={`Logo de ${name}`}
              onLoad={() => setImageLoaded(true)}
              onError={() => setImageError(true)}
            />
          </div>
        )}

        <span className="ml-4 geomanistRegular text-xl font-bold text-gray-900">
          {name}
        </span>

        <svg
          className="ml-auto w-10 h-10 text-gray-400"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fillRule="evenodd"
            d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
            clipRule="evenodd"
          />
        </svg>
      </div>
    </div>
  );
};

export default CompanyTile;
